import { Col, Row } from 'react-bootstrap';
import React, { useEffect, useState } from 'react';

import Img from 'gatsby-image';
import ReactMarkdown from 'react-markdown';
import SEO from '../../components/seo';
import SidePhoto from '../../components/SidePhoto';
import TrailTitle from '../../components/TrailTitle';
import { graphql } from 'gatsby';

const InpatientPage = ({ data, location }) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setOpen((o) => !o);

    return () => {
      setOpen((o) => !o);
    };
  }, []);

  // const rooms = [
  //   { name: 'CARABELLI 1', class: 1, total: 2 },
  //   { name: 'CARABELLI 2 F', label: 'Perempuan', class: 3, total: 4 },
  //   { name: 'CARABELLI 2 M', label: 'Laki-laki', class: 3, total: 4 },
  //   { name: 'RUANG ISOLASI', total: 1 },
  //   { name: 'RUANG ICU', total: 1 },
  // ]

  // const kamar = rooms
  //   .map(n => {
  //     const rgmImage = data.rooms.edges.find(x => x.node.name === n.name);
  //     if (!rgmImage) return null;
  //     return {
  //       ...rgmImage,
  //       ...n
  //     };
  //   })
  //   .filter(Boolean);

  const kamar = []

  return (
    <>
      <SEO title='Layanan Rawat Inap' pathname='/services/inpatient' />
      <Img fluid={data.inpatient.cover.value.childImageSharp.fluid} />
      <Row
        css={{
          minHeight: '75vh',
          backgroundImage: `url(${data.bg.childImageSharp.fixed.src})`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'top right',
        }}
        className='pt-5'>
        <Col
          sm={'5'}
          className='d-flex flex-column align-items-center align-content-center'>
          <TrailTitle open={open} className='pb-2 mb-5'>
            <div>Layanan</div>
            <div>Rawat Inap</div>
          </TrailTitle>
          <SidePhoto>
            {data.inpatient.side.value.map((img, idx) => (
              <Img key={idx} fluid={img.childImageSharp.fluid} />
            ))}
          </SidePhoto>
        </Col>
        <Col className='d-flex flex-column align-items-center align-content-center pl-3 pr-3 pt-1'>
          <ReactMarkdown
            source={data.inpatient.description.value}
            escapeHtml={false}
          />
          <div style={{ width: '100%' }} className='my-lg-4 my-3'>
            <h4 className="font-weight-bold mb-3">SK Penetapan Jumlah Bed Rawat Inap </h4>
            <Img fluid={data.skinap.childImageSharp.fluid} />
          </div>
          <div style={{ width: '100%' }} className='my-lg-4 my-3'>
            <h4 className="font-weight-bold mb-3">Fasilitas Pelayanan Rawat Inap</h4>
            <Row className='align-items-center justify-content-between'>
              {data.rooms.edges.map((edge, index) => {
                const node = edge.node;
                const title = node.title ? node.title.value : '';
                const label = node.label ? node.label.value : '';
                const total = node.total ? node.total.value : 0;
                const kelas = node.kelas ? node.kelas.value : '';
                const image = node.img?.value?.childImageSharp?.fluid;

                return (
                  <Col key={index} md={6} className='p-3'>
                    <div>
                      <div className="mb-2">
                        <h5 className="font-weight-bold">Ruang {title} {label ?? ''}</h5>
                        <p>{kelas && `Kelas ${kelas} | `}{total ? `Jumlah Bed: ${total}` : ''}</p>
                      </div>
                      {image && (
                        <Img fluid={image} className="img-fluid" style={{ aspectRatio: '16 / 9' }} />
                      )}
                    </div>
                  </Col>
                );
              })}

              {kamar && kamar.map((room, idx) => (
                <Col key={idx} md={6} className='p-3'>
                  <div >
                    <div className="mb-2">
                      <h5 className="font-weight-bold">{idx < 3 && 'R. '}{room.name} {room.label && `(${room.label})`}</h5>
                      <p>{room.class && `Kelas ${room.class} | `}Jumlah Bed : {room.total}</p>
                    </div>
                    <Img fluid={room.node.childImageSharp.fluid} className="img-fluid" style={{ aspectRatio: '16 / 9' }} />
                  </div>
                </Col>
              ))}
            </Row>
          </div>
        </Col>
      </Row>
    </>
  );
};

export const query = graphql`
  {
    inpatient: cockpitServices(cockpitId: { eq: "5fe05e723138660cda0001bf" }) {
      description {
        type
        value
      }
      cover: cover_photo {
        type
        value {
          childImageSharp {
            fluid(maxWidth: 1920, toFormat: WEBP) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
      side: other_photos {
        type
        value {
          childImageSharp {
            fluid(toFormat: WEBP) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    }
    bg: file(name: { eq: "bg-ring" }) {
      childImageSharp {
        fixed(toFormat: WEBP) {
          ...GatsbyImageSharpFixed_withWebp
        }
      }
    }
    skinap: file(name: { eq: "sk-bed-inap" }) {
      childImageSharp {
        fluid(toFormat: WEBP) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
    rooms: allCockpitKamarRanap {
      edges {
        node {
          title {
            value
          }
          label {
            value
          }
          kelas {
            value
          }
          total {
            value
          }
          img {
            value {
              childImageSharp {
                fluid(toFormat: WEBP) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
        }
      }
    }
  }
`;

export default InpatientPage;
